(function () {
  'use strict';

  var CAP = 3;
  var MSG = 'You can choose up to 3 free samples in total. Please adjust your selection.';

  var FORM_SEL = 'form[action*="/cart/add"]';
  var ID_SEL   = '[name="id"]';
  var QTY_SEL  = '[name="quantity"]';

  var pm = window.location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!pm) return;
  var handle = pm[1];

  var priceByVariant = {};
  var usedSamples = 0;
  var loaded = false;

  function form()  { return document.querySelector(FORM_SEL); }
  function qtyEl() { var f = form(); return f && f.querySelector(QTY_SEL); }

  function selectedVariantId() {
    var f = form(); if (!f) return null;
    var el = f.querySelector(ID_SEL);
    return el ? parseInt(el.value, 10) : null;
  }

  function selectedIsSample() {
    var id = selectedVariantId();
    return id != null && priceByVariant[id] === 0;
  }

  // "Buy it now" / express buttons skip the cart and our submit gate, so
  // po-sample-cap.css hides them while a sample variant is selected.
  document.documentElement.classList.add('po-sample-selected'); // until prices load

  function capQtyField() {
    document.documentElement.classList.toggle('po-sample-selected', !loaded || selectedIsSample());
    var q = qtyEl(); if (!q) return;
    if (!selectedIsSample()) { q.removeAttribute('max'); return; }
    var remaining = Math.max(0, CAP - usedSamples);
    q.setAttribute('max', String(remaining));
    if ((parseInt(q.value, 10) || 1) > remaining) q.value = String(Math.max(1, remaining));
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        usedSamples = (c.items || []).reduce(function (n, l) {
          return l.price === 0 ? n + l.quantity : n;
        }, 0);
        capQtyField();
      });
  }

  fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      (p.variants || []).forEach(function (v) { priceByVariant[v.id] = v.price; });
      loaded = true;
      return refreshCart();
    })
    .catch(function () { document.documentElement.classList.remove('po-sample-selected'); });

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest(FORM_SEL)) capQtyField();
  }, true);

  document.addEventListener('submit', function (e) {
    if (!loaded || !selectedIsSample()) return;
    var f = form(); if (!f || f !== e.target) return;
    var want = parseInt((qtyEl() && qtyEl().value) || '1', 10) || 1;
    if (usedSamples + want > CAP) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.alert(MSG);
    }
  }, true);

  // Refresh the cached count after any add-to-cart completes, so a second
  // add on the same page (no reload) sees the real, up-to-date total.
  if (window.theme && theme.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, refreshCart);
  }
  document.addEventListener('ajaxProduct:added', refreshCart);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCart();
  });
})();
